var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.servicenamechat !== "Thewolf"
    ? _c(
        "div",
        {
          staticClass: "cursorpointer",
          style:
            "background-color: " +
            _vm.backgroundText +
            "; height:30px; border-radius: 10px;",
          attrs: { none: "" }
        },
        [
          _c(
            "h4",
            {
              staticClass: "centerDiv",
              staticStyle: { color: "white", "margin-top": "5px !important" }
            },
            [_vm._v("แชทกับเจ้าหน้าที่ OSS")]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c4bf1ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c4bf1ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MinChat.vue
// module id = null
// module chunks = 